import React from 'react';

import { Field, reduxForm } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const validate = values => {
    const errors = {};
    if (!values.email) {
        errors.email = 'Required';
    }

    return errors
};

const renderField = ({ input, label, type, meta: { asyncValidating, touched, error } }) => (
    <div>
        <TextField label={label} hint={label} type={type} {...input}
                   error={touched && error ? true : false}
                   helperText={touched && error ? error : ''}
                   margin="normal"
                   style={{width:250}}/>
    </div>
);

const ForgotPasswordForm = (props) => {
    const { handleSubmit,
        // submitting
    } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field name="emailOrPhoneNumber" type="text" component={renderField} label="Email or phone number"/>
            <Button color="secondary" variant="contained" onClick={handleSubmit}>Submit</Button>
        </form>
    )
};

export default reduxForm({
    form: 'ForgotPasswordForm', // a unique identifier for this form
    validate
})(ForgotPasswordForm)
